<div>
    <app-branch-settings-list></app-branch-settings-list>
</div>
<div>
    <app-branch-settings-form></app-branch-settings-form>
</div>